import { render, staticRenderFns } from "./message.vue?vue&type=template&id=7c476c54&scoped=true"
import script from "./message.vue?vue&type=script&lang=ts"
export * from "./message.vue?vue&type=script&lang=ts"
import style0 from "./message.vue?vue&type=style&index=0&id=7c476c54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c476c54",
  null
  
)

export default component.exports